import React from "react";
import { classIf } from '../../data/utils/classIf';
import { getLabel } from "../../data/labels";
import { urls } from "../..";
import XRouterLink from "../../common/seo/xrouter/XRouterLink";

export default function HighlightedTournamentsButton() {
    const url = `${urls.basename}/${urls.prematch.base}/${urls.prematch.tournament}/top`;
    
    return (
        <XRouterLink to={url} className={"relative h-sports-navbar-height min-w-sports-navbar-height mx-1 shrink-0 flex flex-col items-center justify-center" + classIf(false, 'xs_selected')} onClick={() => {}}>
            <div className="min-w-[60px] grid grid-cols-12 grid-rows-12 max-h-full leading-none items-center justify-items-center highlightedTournaments__btn">
                <img className={"xs-sport-icon col-start-1 col-end-13 row-start-1 row-end-10 inline-block h-[24px] w-[24px]"} src={`${process.env.PUBLIC_URL}/assets/images/star.svg`} alt="" />
                <div className="col-start-1 col-end-13 row-start-10 row-end-13 font-bold text-xxs text-cs1 uppercase truncate">{getLabel('prematch.top_tournaments', 'Top leagues')}</div>
            </div>
            {/* {isSelected &&
                <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-cs4 rounded-xl"></div>
            } */}
        </XRouterLink>
    );
}
